var map = {
	"./after_1.jpg": 2102,
	"./after_2.jpg": 2449,
	"./after_3.jpg": 4404,
	"./after_4.jpg": 9343,
	"./after_5.jpg": 6962,
	"./after_6.jpg": 6861,
	"./after_7.jpg": 5728,
	"./before_1.jpg": 6815,
	"./before_2.jpg": 6496,
	"./before_3.jpg": 4589
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6130;